import { getEnvironment } from '@/utils/env-helper'

class FreshchatService {
  static freshchatInitialized = false

  static getFcWidget() {
    // @ts-ignore
    if (!window.fcWidget) {
      console.error('freshchat not installed')
      return null
    }

    if (!this.freshchatInitialized) {
      this.initFreshchat()
    }
    // @ts-ignore
    return window.fcWidget
  }

  static initFreshchat() {
    if (getEnvironment() === 'Development') {
      return
    }

    // @ts-ignore
    window.fcWidget.init({
      token: '959dd01e-ed03-4c91-aa7b-028043b67b35',
      host: 'https://wchat.freshchat.com',
      onInit() {
        // @ts-ignore
        window.fcWidget.on('widget:closed', () => {
          // @ts-ignore
          document.getElementById('fc_frame').style.display = 'none'
        })
      },
    })
  }

  static openFreshchat() {
    const element = document.getElementById('fc_frame')
    if (element) {
      element.style.display = 'block'
    }

    if (this.getFcWidget()) {
      this.getFcWidget().open()
    }
  }

  static closeFreshchat() {
    if (this.getFcWidget()) {
      this.getFcWidget().close()
    }
  }

  static setFreshchatInfo(currentUser: any) {
    const fcWidget = this.getFcWidget()

    if (!fcWidget) {
      return false
    }

    try {
      if (!currentUser) {
        console.error('No user!')
        return false
      }

      fcWidget.user.setProperties({
        id: currentUser.id,
        firstName: currentUser.name,
        email: currentUser.email,
        businessType: currentUser?.businessType?.slug ?? 'unset',
        verified: !!currentUser.verified,
        items_count: currentUser.items_count,
        phone: currentUser.phone,
        restaurant_name: currentUser.restaurant_name,
      })
    } catch (error) {
      console.error('Set freshchat user failed', error)
    }
    return true
  }
}

export default FreshchatService
